var path = 'src/app/hospitals/hospital-detail.html';
var html = "<div page-wrapper> <h1 class=page-header>{{hospital.name}} <small>{{hospital.code}}</small></h1> <div patients-by-recruitment-date-graph group=hospital></div> <h2>Cohorts</h2> <div patients-by-group-table group=hospital group-type=COHORT></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/hospitals/hospital-detail.html
 ** module id = 360
 ** module chunks = 0
 **/